import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";
const urlProd = process.env.REACT_APP_URL_DIR + "giftcardpier/";

export function GetGiftcardpier() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Giftcardpier"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}

export function GetGiftcardpierIns() {
   const token = localStorage.getItem("token");
   const { data } = useQuery({
      queryKey: ["Giftcardpier"],
      queryFn: () =>
         fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         }).then((res) => res.json())
   });

   return data;
}
